<script lang="ts" setup>
	const props = defineProps<{
		file: File | null
		progress: number
	}>()
	const fileSize = computed(() => {
		if (props.file) {
			return (props.file.size / 1024).toFixed(2)
		}
		return 0
	})
</script>

<template>
	<div
		class="mx-auto flex min-h-[200px] w-full flex-col items-center rounded-lg border border-gray-300 bg-gray-100 px-5 py-10"
	>
		<div class="gpa-5 flex w-full items-center justify-between">
			<div class="flex items-center gap-x-3">
				<lazy-tools-icon icon="excel-uploading-icon" dir="documents" />
				<div class="space-y-1.5">
					<h4 class="font-medium text-gray-500">
						{{ file?.name || 'N/A' }}
					</h4>
					<p class="text-xs text-gray-600"> {{ fileSize }}kB </p>
				</div>
			</div>

			<div class="space-y-2">
				<lazy-tools-icon dir="line" icon="cancel" />
				<p class="text-sm font-medium text-gray-600"> {{ progress || 0 }}% </p>
			</div>
		</div>
		<div class="mt-10 w-full">
			<a-progress :percent="progress || 0" class="custom-progress w-full" :show-info="false" />
		</div>
	</div>
</template>

<style scoped>
	.custom-progress :deep(.ant-progress-bg) {
		@apply bg-primary-2;
	}
</style>
